import React from 'react';
import PropTypes from 'prop-types';
import {TableCell, TableRow} from 'material-ui/Table';
import {withStyles} from 'material-ui/styles';
import {MenuItem} from 'material-ui/Menu';
import FormattedDate from '../../common/formatted-date/index';
import AdminMenu from '../../common/menu/index';
import CellText from '../../common/cell-text/index';
import FolderIcon from 'material-ui-icons/Folder';
import Avatar from 'material-ui/Avatar';

const style = theme => ({
	row: {
		height: theme.spacing.unit * 8
	},
	avatar: {
		backgroundColor: theme.palette.secondary[500],
		cursor: 'pointer'
	},
	avatarColumn: {
		width: 48
	},
	poster: {
		width: 'auto',
		height: '100%'
	},
	nameColumn: {
		cursor: 'pointer'
	},
	textColumn: {
		width: '50%'
	},
	dateColumn: {
		width: 180,
		boxSizing: 'border-box',
		whiteSpace: 'nowrap'
	},
	actionColumn: {
		width: 48
	},
	actionButton: {
		width: 48,
		height: 47,
		overflow: 'hidden'
	}
});

const icon = (
	<FolderIcon/>
);

const AdminCollectionItem = props => {
	const {
		classes,
		item,
		filesCount,
		poster,
		onShowFiles,
		onEdit,
		onDelete
	} = props;

	return (
		<TableRow className={classes.row}>
			<TableCell className={classes.avatarColumn} padding="checkbox">
				<Avatar className={classes.avatar} onClick={onShowFiles}>
					{poster ? (<img className={classes.poster} src={poster} alt=""/>) : icon}
				</Avatar>
			</TableCell>
			<TableCell
				className={`${classes.textColumn} ${classes.nameColumn}`}
				padding="none"
				onClick={onShowFiles}
			>
				<CellText>
					{item.name}
				</CellText>
			</TableCell>
			<TableCell className={classes.textColumn} padding="dense">
				<CellText>
					{item.description}
				</CellText>
			</TableCell>
			<TableCell padding="dense" numeric>
				{filesCount}
			</TableCell>
			<TableCell className={classes.dateColumn} padding="dense">
				<FormattedDate date={item.updatedAt}/>
			</TableCell>
			<TableCell className={classes.actionColumn} padding="none">
				<AdminMenu className={classes.actionButton}>
					<MenuItem onClick={onShowFiles}>Show Files</MenuItem>
					<MenuItem onClick={onEdit}>Edit</MenuItem>
					<MenuItem onClick={onDelete}>Delete</MenuItem>
				</AdminMenu>
			</TableCell>
		</TableRow>
	);
};

AdminCollectionItem.propTypes = {
	classes: PropTypes.object.isRequired,
	item: PropTypes.object.isRequired,
	filesCount: PropTypes.number.isRequired,
	onShowFiles: PropTypes.func.isRequired,
	onEdit: PropTypes.func.isRequired,
	onDelete: PropTypes.func.isRequired,
	poster: PropTypes.string
};

export default withStyles(style)(AdminCollectionItem);



// WEBPACK FOOTER //
// ./src/client/components/admin/collections/item/item.jsx